function systemNumbers(system: string): number[] {
    return system.split('/').map((x: string) => parseInt(x, 10));
}

export default function numericalSystemComparator(o1: { name: string }, o2: { name: string }): number {
    const [guessed1, possible1] = systemNumbers(o1.name);
    const [guessed2, possible2] = systemNumbers(o2.name);

    if (guessed1 < guessed2) {
        return -1;
    }
    if (guessed1 > guessed2) {
        return 1;
    }
    if (possible1 > possible2) {
        return 1;
    }
    if (possible1 < possible2) {
        return -1;
    }

    return 0;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/sortComparators/numericalSystemComparator.ts